<template>
  <div class="histort-quote-box">
    <div class="title">历史报价单信息</div>
    <div
      class="history-quote-item-box"
      v-for="(historyItem, historyIndex) in copyData"
      :key="historyIndex"
    >
      <div
        class="bg-header"
        :class="historyItem.isShowInfo ? 'rotateIcon' : ''"
        @click="historyItem.isShowInfo = !historyItem.isShowInfo"
      >
        <div>
          <i class="icon-rejected" v-if="isExpired(historyItem.validDate)"></i>
          <span class="text"
            >报价时间：{{
              moment(historyItem.createTime).format('YYYY-MM-DD HH:mm:ss')
            }}</span
          >
          <span class="text">报价编号：{{ historyItem.id }}</span>
        </div>
        <i class="el-icon-arrow-up rotateBox" style="color: #666666"></i>
      </div>
      <el-collapse-transition>
        <div class="content" v-if="historyItem.isShowInfo">
          <div style="padding: 16px">
            <quoteGridDescriptions
              title="报价单信息"
              :sourceData="[
                {
                  name: '报价时间',
                  label: 'submitTime',
                  value: historyItem.submitTime || '--',
                },
                {
                  name: '支付条款',
                  label: 'paymentTerms',
                  value: historyItem.paymentTerms || '--',
                },
                {
                  name: '报价有效期',
                  label: 'validDate',
                  value: historyItem.validDate || '--',
                },
                {
                  name: '货运条款',
                  label: 'shippingTermsStr',
                  value: historyItem.shippingTermsStr || '--',
                },
                {
                  name: '报价货币',
                  label: 'currency',
                  value: historyItem.currency || '--',
                },
                {
                  name: '交货地点',
                  label: 'freightAddrVo',
                  value: historyItem.freightAddrVo || '--',
                },
                {
                  name: '报价说明',
                  label: 'remark',
                  value: historyItem.remark || '--',
                },
                {
                  name: '报价附件',
                  label: 'attachments',
                  value: historyItem.attachments || '--',
                },
              ]"
              :column="2"
            >
              <template #submitTime="{ item }">
                <span class="description-value" v-if="item && item.value">
                  {{
                    item.value !== '--'
                      ? moment(item.value).format('YYYY-MM-DD HH:mm:ss')
                      : '--'
                  }}
                </span>
              </template>
              <template #validDate="{ item }">
                <p class="description-value" v-if="item && item.value">
                  <span v-if="!isExpired(item.value)">{{
                    moment(item.value).format('YYYY-MM-DD')
                  }}</span>
                  <span v-else style="color: #ff081f"
                    >{{
                      moment(item.value).format('YYYY-MM-DD')
                    }}（已过期）</span
                  >
                </p>
              </template>
              <template #freightAddrVo="{ item }">
                <p class="description-value" v-if="item && item.value">
                  <span v-if="item.value.id"
                    >{{ address(item.value) }}
                    <span>&nbsp;{{ item.value.postCode }}</span>
                  </span>
                  <span v-else>--</span>
                </p>
                <span class="description-value" v-else>
                  {{ '--' }}
                </span>
              </template>
              <template #remark="{ item }">
                <span
                  class="description-value"
                  v-html="formatText(item.value)"
                ></span>
              </template>
              <template #attachments="{ item }">
                <div class="file-list-show-box" v-if="item.value?.length > 0">
                  <p
                    class="file-item"
                    style="color: #0863ff; font-size: 14px"
                    v-for="(fileItem, fileIndex) in item.value"
                    :key="fileIndex"
                  >
                    <i
                      class="iconfont icon-attach"
                      style="margin-right: 4px"
                    ></i>
                    <a @click="handleDowload(fileItem)">{{ fileItem.name }}</a>
                  </p>
                </div>
                <span class="description-value" v-else>
                  {{ '--' }}
                </span>
              </template>
            </quoteGridDescriptions>
          </div>
          <partTableInfo
            :part-info-list="initHistoryQuoteItem(historyItem)"
            :detail-info="historyItem"
            ref="partTableInfoRef1"
            :isEdit="false"
          ></partTableInfo>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import partTableInfo from './part-table-info.vue'
import quoteGridDescriptions from './quote-grid-descriptions.vue'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import { fileUrl, onlineUrl, companyLogoUrl } from '@/utils/config.js'
export default {
  name: 'historyQuote',
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
    historyData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      copyData: [],
    }
  },
  methods: {
    moment,
    formatText(text) {
      return text.replace(/\n/g, '<br>')
    },
    handleDowload(item) {
      const a = document.createElement('a')
      a.href = `${onlineUrl}${item.url}`
      a.target = '_blank'
      a.download = item.name || 'download' // 设置下载文件名
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    showRejectedIcon(time1, time2) {
      if (!time1 || !time2) {
        return false
      }
      let time1Moment = moment(time1).endOf()
      let time2Moment = moment(time2).endOf()
      return time2Moment.isBefore(time1Moment)
    },
    address(freightAddrVo) {
      const { stateIdStr, provinceIdStr, cityIdStr,cityId } = freightAddrVo
      return [stateIdStr, provinceIdStr, !cityId ? undefined : cityIdStr].filter(Boolean).join('，')
    },
    isExpired(targetDate) {
      const todayStart = moment().startOf('day')
      const targetMoment = moment(targetDate).startOf('day')
      return targetMoment.isBefore(todayStart) // 目标日期是否早于今天
    },
    initHistoryQuoteItem(sourceRecord) {
      const copyData = JSON.parse(JSON.stringify(sourceRecord))
      copyData.parts = (copyData.partsInfos || []).map((k) => {
        const quantityFields = ['quoteNum1', 'quoteNum2', 'quoteNum3']
        const existingQuantityFields = quantityFields.filter(
          (field) => k[field]
        )
        const quoteLength = Array.from(
          { length: existingQuantityFields.length },
          (_, index) => index + 1
        )
        return {
          ...k,
          partPriceInfoList: quoteLength.map((l) => {
            return {
              numQuantity: k[`quoteNum${l}`],
              ...k.quotePrice.reduce((acc, cur, index, thisArr) => {
                if (1 <= cur.itemType <= 4) {
                  acc[`num${cur.itemType}`] = thisArr[index][`value${l}`]
                }
                return acc
              }, {}),
            }
          }),
        }
      })
      return copyData.parts || []
    },
    changeShowStatus(item, index) {
      this.$emit('changeShowStatus', { item, index })
    },
  },
  mounted() {
    //
  },
  components: {
    partTableInfo,
    quoteGridDescriptions,
    'el-collapse-transition': CollapseTransition,
  },
  watch: {
    historyData: {
      immediate: true,
      handler(val) {
        this.copyData = JSON.parse(JSON.stringify(val))
      },
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.histort-quote-box {
  padding: 16px;
  .title {
    color: #333333;
    text-align: justify;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
  }
  .history-quote-item-box {
    border: 1px solid #e9edf1;
    margin-top: 16px;
    .bg-header {
      cursor: pointer;
      display: flex;
      padding: 8px 24px;
      background: #f5f7fa;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .text {
        color: #333333;
        text-align: justify;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-right: 24px;
      }
    }
  }
}
.icon-rejected {
  width: 32px;
  height: 32px;
  background: url('../../../../assets/image/reject-icon.png') no-repeat center
    center;
  background-size: cover;
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
}
.rotateIcon {
  .rotateBox {
    transform: rotate(180deg);
  }
}
</style>
